import { render, staticRenderFns } from "./AddNekretnine.vue?vue&type=template&id=785661c8&scoped=true&"
import script from "./AddNekretnine.vue?vue&type=script&lang=js&"
export * from "./AddNekretnine.vue?vue&type=script&lang=js&"
import style0 from "./AddNekretnine.vue?vue&type=style&index=0&id=785661c8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "785661c8",
  null
  
)

export default component.exports